import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BaseService } from 'src/app/services/providers/base.service';
import { UserActivityService } from 'src/app/services/userActivity.service';
import { ILoginRequestTM } from '../../models/requests/loginRequestTM.interface';
import { ILoginResponseTM } from '../../models/user/loginResponseTM.interface';
import { StorageService } from 'src/app/services/util/storage.service';

@Injectable({providedIn: 'root'})
export class TicketManagerUserProviderService extends BaseService {

  constructor(
    private http: HttpClient,
    protected loaderService: LoaderService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storage: StorageService) {
    super(loaderService, userActivityService, notificationService, storage);
  }


  login(reqest: ILoginRequestTM): Observable<ILoginResponseTM> {
    const url = this.baseUrlWebTicketManager + 'Login';
    const body = JSON.stringify(reqest);
    const params = new HttpParams();

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map(response => response as ILoginResponseTM),
      catchError(err => of(null))
    );
  }
}
